module.exports = __webpack_public_path__ + "img/sh.0b974c44.svg";